module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "d-flex mb-4 section-title-container wrap txt-center align-center",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_c('truck-svg'), _vm._v(" "), _c('h2', {
    staticClass: "uppercase section-title"
  }, [_vm._v("¿COMÓ QUIERES RECIBIR TU PRODUCTO?")])], 1), _vm._v(" "), _c('section', {
    staticClass: "mb-3 d-flex space-between align-center"
  }, [(_vm.isDelivery) ? _c('special-button', {
    staticClass: "flex-40 mx-1",
    attrs: {
      "text": "Envío a domicilio",
      "value": _vm.houseReception
    },
    on: {
      "on-click": function($event) {
        _vm.clicked(1)
      }
    }
  }, [_c('location-svg', {
    attrs: {
      "slot": "svg",
      "active": _vm.houseReception
    },
    slot: "svg"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isStore) ? _c('special-button', {
    staticClass: "flex-40 mx-1",
    attrs: {
      "text": "Recoger en tienda",
      "value": _vm.storeReception
    },
    on: {
      "on-click": function($event) {
        _vm.clicked(2)
      }
    }
  }, [_c('store-svg', {
    attrs: {
      "slot": "svg",
      "active": _vm.storeReception
    },
    slot: "svg"
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.houseReception) ? _c('section', [_c('responsible-form'), _vm._v(" "), _c('select-address-component', {
    staticClass: "mb-3 mx-1",
    attrs: {
      "no-map": false,
      "placeholder": "Dirección",
      "item-text": "name",
      "item-value": "id",
      "options": _vm.housesAddress
    },
    on: {
      "input": _vm.updateAddress
    },
    model: {
      value: (_vm.houseAddress),
      callback: function($$v) {
        _vm.houseAddress = $$v
      },
      expression: "houseAddress"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.newAddressFlag && _vm.houseReception) ? _c('section', [_c('address-form')], 1) : _vm._e(), _vm._v(" "), (_vm.storeReception) ? _c('section', [_c('select-address-component', {
    staticClass: "mb-3 mx-1",
    attrs: {
      "placeholder": "Dirección",
      "item-text": "name",
      "item-value": "id",
      "item-title": "name",
      "options": _vm.storesAddress
    },
    on: {
      "input": _vm.updateAddress
    },
    model: {
      value: (_vm.storeAddress),
      callback: function($$v) {
        _vm.storeAddress = $$v
      },
      expression: "storeAddress"
    }
  }), _vm._v(" "), _c('responsible-form')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5607c100","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy/deliveryProducts.vue
// module id = 1119
// module chunks = 32